import { useMemo, useState } from 'react'
import { Box } from '@mui/material'
import EventsPageHero from '../components/events/EventsPageHero'
import EventsListBlock from '../components/events/EventsListBlock'
import EventsFilterTabs from '../components/events/EventsFilterTabs'
import {
  eventsPageUpcoming,
  eventsPageAll,
  filterEventsByCategory,
} from '../data/eventsContent'
import {
  programSectionWrapperSx,
  programInnerSx,
  programSectionGap,
} from '../components/programs/programLayout'

export default function EventsPage() {
  const [activeFilter, setActiveFilter] = useState('all')

  const filteredEvents = useMemo(
    () => filterEventsByCategory(eventsPageAll, activeFilter),
    [activeFilter],
  )

  return (
    <Box>
      <EventsPageHero />

      <Box sx={{ ...programSectionWrapperSx, pb: { xs: 8, md: 12, lg: '150px' } }}>
        <Box
          sx={{
            ...programInnerSx,
            display: 'flex',
            flexDirection: 'column',
            gap: programSectionGap,
          }}
        >
          <EventsListBlock title="Upcoming Events" events={eventsPageUpcoming} />

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 5, md: '60px' } }}>
            <EventsFilterTabs activeFilter={activeFilter} onFilterChange={setActiveFilter} />
            <EventsListBlock title="All Events" events={filteredEvents} />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
